import styled from "styled-components";
import Card from "antd/es/card";

export const ReviewContainer = styled.div`
  ${({ theme }) => `
  padding: 0 ${theme.paddingContentHorizontalLG}px;
  margin: 0 auto;
`}
`;

export const SummaryCard = styled(Card)`
  ${({ theme }) => `
  margin-bottom: ${theme.marginLG}px;

  .ant-card-body {
    padding: ${theme.paddingLG}px;
  }
`}
`;

export const InstructionsCard = styled(Card)`
  ${({ theme }) => `
  margin-bottom: ${theme.marginLG}px;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: ${theme.fontFamily};
    font-size: ${theme.fontSizeSM}px;
    line-height: ${theme.lineHeightSM};
  }
`}
`;

export const CapabilitiesGrid = styled.div`
  ${({ theme }) => `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: ${theme.marginSM}px;
  margin-top: ${theme.marginLG}px;
`}
`;

export const CapabilityItem = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.marginXS}px;
  padding: ${theme.paddingXS}px ${theme.paddingSM}px;
  background: ${theme.colorFillQuaternary};
  border-radius: ${theme.borderRadiusSM}px;
`}
`;

export const ConfigSection = styled.div`
  ${({ theme }) => `
  margin-top: ${theme.margin}px;
  padding: ${theme.padding}px;
  background: ${theme.colorFillQuaternary};
  border-radius: ${theme.borderRadius}px;
`}
`;
